import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
import CharacterAvatar from './CharacterAvatar';
import Card from '../shared/Card';
import ArtImage from '../art/ArtImage';
import { PORTRAITS } from '../../data/artwork';

const CharacterBioCard = ({ character }) => {
  const [expanded, setExpanded] = useState(false);

  if (!character) return null;

  return (
    <Card variant={character.id} className="p-5">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center gap-4 text-left"
      >
        <CharacterAvatar characterId={character.id} size="lg" />
        <div className="flex-1 min-w-0">
          <h3 className="font-display text-lg font-bold text-courtyard-stone">
            {character.name}
          </h3>
          <p className="text-xs text-courtyard-stone/80 font-medium">
            {character.greekName} &middot; {character.meaning}
          </p>
          <p className="text-sm text-courtyard-stone/80 mt-1 italic">
            &ldquo;{character.quote}&rdquo;
          </p>
        </div>
        {expanded ? (
          <ChevronUp className="w-5 h-5 text-courtyard-stone/80 flex-shrink-0" aria-hidden="true" />
        ) : (
          <ChevronDown className="w-5 h-5 text-courtyard-stone/80 flex-shrink-0" aria-hidden="true" />
        )}
      </button>

      <AnimatePresence>
        {expanded && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden"
          >
            <div className="pt-4 mt-4 border-t border-courtyard-gold/20">
              {PORTRAITS[character.id] && (
                <ArtImage
                  stem={PORTRAITS[character.id].file}
                  alt={PORTRAITS[character.id].alt}
                  width={640}
                  height={640}
                  sizes="(min-width: 640px) 208px, 100vw"
                  className="w-full sm:w-52 sm:float-left sm:mr-5 mb-4 aspect-square object-cover rounded-xl border border-courtyard-gold/40 shadow-courtyard-sm"
                />
              )}
              <p className="text-sm text-courtyard-stone/80 leading-relaxed whitespace-pre-line">
                {character.bio}
              </p>
              <div className="mt-3 flex flex-wrap gap-2 clear-both">
                <span className="text-xs bg-courtyard-gold/10 text-courtyard-gold-ink px-2 py-1 rounded-full">
                  {character.archetype}
                </span>
                <span className="text-xs bg-courtyard-stone/5 text-courtyard-stone/80 px-2 py-1 rounded-full">
                  {character.domain}
                </span>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </Card>
  );
};

export default CharacterBioCard;
